import React, { useState, useContext } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Layout, Menu } from 'antd'
import { RightCircleOutlined, LeftCircleOutlined } from '@ant-design/icons'
import SettingContext from '../../contexts/settingProvider'
import logo from '../../images/logo.svg'
import logo_s from '../../images/logo_s.svg'
import logo_icon from '../../images/logo_icon.svg'
import { menu as sideMenu } from '../../utils/functionTool'

const { Sider } = Layout
const removeLastSlash = (str) => {
    let input = str
    let parts = input.split('/')
    if (parts.length > 2) {
        parts.pop()
        input = parts.join('/')
    }
    return input
}
const siderStyle = {
    overflow: 'auto',
    height: '100vh',
    position: 'sticky',
    top: 0,
    bottom: 0,
};
const Sidebar = () => {
    const [collapsed, setCollapsed] = useState(true)
    const { dark } = useContext(SettingContext)
    const { pathname } = useLocation()

    return (
        <Sider
            collapsible
            className="app-aside"
            collapsed={collapsed}
            collapsedWidth={60}
            onCollapse={(value) => setCollapsed(value)}
            trigger={
                collapsed ? <RightCircleOutlined /> : <LeftCircleOutlined />
            }
            style={siderStyle}
        >
            <div className="app-logo-wrap">
                <div
                    className={`app-logo ${
                        !collapsed ? '' : 'app-logo-collapsed'
                    }`}
                >
                    {!collapsed ? (
                        <Link to="/">
                            <img
                                src={dark ? logo_s : logo}
                                alt="微電能源-能源管理系統"
                                style={{ width: 136 }}
                            />
                        </Link>
                    ) : (
                        <Link to="/">
                            <img src={logo_icon} alt="微電能源-能源管理系統" />
                        </Link>
                    )}
                </div>
            </div>
            <Menu
                theme={dark ? 'dark' : 'light'}
                mode="inline"
                className="app-aside-menu"
                inlineIndent={16}
                selectedKeys={[removeLastSlash(pathname)]}
                items={sideMenu}
            />
        </Sider>
    )
}

export default Sidebar
